import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiHelpCircle } from 'react-icons/fi';

export default function LogisticOrderGroup() {
  const cards = [1, 2, 3, 4];
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F1F3F2] flex flex-col max-w-md mx-auto relative">
      {/* Header */}
      <div className="bg-white px-5 py-4 flex items-center justify-center relative border-b border-gray-100">
        <button className="absolute left-5" type="button" onClick={() => navigate(-1)}>
          <FiArrowLeft size={24} color="#000000" />
        </button>
        <h1 className="text-xl font-bold text-black">ID</h1>
      </div>

      {/* Main Content */}
      <div className="flex-1 bg-[#F1F3F2] px-4 py-4 overflow-y-auto pb-52">
        {cards.map((item, index) => (
          <div key={index} className="bg-white rounded-lg p-3 mb-3 flex gap-3 shadow-sm">
            <img 
              loading="lazy"
              src="https://placehold.co/100x120/87CEEB/ffffff?text=Products" 
              alt="Product" 
              className="w-24 h-28 rounded-lg object-cover"
            />
            <div className="flex-1 flex flex-col justify-between py-1 text-left">
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <p className="text-sm font-bold text-black mb-0.5">Product ID</p>
                  <p className="text-sm text-black mb-0.5">Payment On Delivery</p>
                  <p className="text-sm text-black mb-0.5">Buyer Location</p>
                  <p className="text-sm text-black mb-0.5">Pickup Location</p>
                  <p className="text-sm text-black mb-0.5">B*******r (number will display when added to delivery)</p>
                </div>
                <FiHelpCircle size={20} color="#19C463" className="ml-2 mt-1 flex-shrink-0" />
              </div>
              <p className="text-sm font-bold text-black mt-2">Available for Pickup</p>
            </div>
          </div>
        ))}
      </div>

      {/* Bottom Section */}
      <div className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-[#F1F3F2] px-4 py-4 pb-8">
        <div className="bg-white rounded-lg p-3 mb-2">
          <p className="text-base font-bold text-black">Delivery Cost: 5,000</p>
        </div>
        <div className="bg-white rounded-lg p-3 mb-3">
          <p className="text-base font-bold text-black">Pickup from - [pickup location]</p>
        </div>
        <button className="w-full bg-[#19C463] text-white text-base font-bold py-3.5 rounded-md">
          Add to Delivery
        </button>
      </div>
    </div>
  );
}
